import Swal from 'sweetalert2';

export function showErrorMessage(err, props) {
	let errText = '';
	console.log('handle Error=====>', err);
	if (err.data) {
		errText = err?.data?.message ?? err?.data?.errors ?? 'Something went wrong!';
		console.log('errText====>', errText, err);
		if (typeof errText === 'object') {
			errText = Object?.values(errText).join(', ');
		}
		Swal.fire({
			allowOutsideClick: false,
			title: "<div className='pt-5'></div>",
			text: errText,
			// icon: "error",
		}).then(() => {
			if (localStorage.getItem('alkem_token')) {
				if (err.data.status === 5) {
					localStorage.removeItem('alkem_token');
					window.location.href = `${process.env.REACT_APP_BASENAME || ''}/`;
				}
				//props.history.push('/admin');
				// window.location.href = "/";
			} else {
				//props.history.push('/');
				// window.location.href = "/";
			}
		});
	} else {
		Swal.fire({
			allowOutsideClick: false,
			title: "<div className='pt-5'></div>",
			text: `Oops! Unable to process your request right now. Please clear any ongoing processes and log out, then back in. If problem continues, contact Indchemie team`,
			// icon: "error",
		}).then(() => {});
	}
}
